import getClient from '../utils/connectServiceClient'

export default async function updateContextAttribute(
  payload: any
) {
  return getClient().post(`/api/updateContactAttributes`, payload)
}
